import { usePersistedState, useViewport } from "@/hooks";
import { RootState } from "@/services/redux/store";
import { useSelector } from "react-redux";
import { Box, Stack } from "../../../includes";
import LazyLoading from "../../Wrappers/components/LazyLoading";
import DesktopWrapper from "../DesktopWrapper";
import MobileWrapper from "../MobileWrapper";
import Navbar from "./components/Navbar";
import TopBar from "./components/TopBar";
import { drawerOpenWith, drawerWidth } from "./enums";
import { ISideMenuWrapper } from "./types";

function SideMenuWrapper({
  wrappedComponent,
  marginContent,
}: ISideMenuWrapper) {
  const siteId = useSelector((state: RootState) => state.site.siteId);
  const { isMobile } = useViewport();

  return (
    <>
      <Stack
        direction="row"
        sx={{
          position: "relative",
          maxWidth: "100vw",
          minHeight: "100vh",
        }}
      >
        <Stack
          sx={{
            width: "100%",
            minHeight: "100vh",
            maxWidth: "100%",
          }}
        >
          <TopBar />

          <Box sx={{ display: "flex" }}>
            <Navbar />

            <Stack
              sx={{
                width: `calc(100vw - ${isMobile ? 0 : drawerOpenWith}px - ${
                  marginContent ? "100px" : "0px"
                })`,
                position: "relative",
                margin: marginContent ? "32px auto 0 auto" : 0,
                overflowX: "hidden",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  position: "relative",
                  margin: "0 auto auto auto",
                }}
                justifyContent="center"
              >
                <Box
                  sx={{
                    width: "100%",
                    paddingTop: 0,
                    paddingBottom: 6,
                    boxSizing: "border-box",
                  }}
                >
                  <LazyLoading component={wrappedComponent} />
                </Box>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Stack>
    </>
  );
}

export default SideMenuWrapper;
